import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class ShortOMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 20;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
            this.markX = this.targetTextField.width/2;
            this.markY = this.adjustToScale(56);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const markXOffset: number = 0;
        const markYOffset: number = 8;

        let mark = new Container();
        let gr = new Graphics();
        gr.moveTo(markXOffset, markYOffset + this.markWidth * 1 / 3);
        gr.quadraticCurveTo(markXOffset + this.markWidth * 1 / 5,
            markYOffset + this.markWidth * 3 / 5,
            markXOffset + this.markWidth / 2,
            markYOffset + this.markWidth * 3 / 5);
        gr.quadraticCurveTo(markXOffset + this.markWidth * 4 / 5,
            markYOffset + this.markWidth * 3 / 5,
            markXOffset + this.markWidth,
            markYOffset + this.markWidth * 1 / 3);
        gr.stroke({color:color, width:this.strokeThickness, cap:"round"});
        mark.addChild(gr);

        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 60,
            fill: color,
            align: 'center'
        });
        const letter = new Text({text:"o", style:style});
        letter.x = (this.markWidth / 2) - (letter.width / 2);
        letter.y = 0;
        mark.addChild(letter);

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}